// Canonical term-sheet digest — recipe v2. Must stay byte-identical with backend/web3_registry.py::canonical_criteria.
// Takes the 85 criteria (keys + kinds from the catalogue), normalises every present value to a string, sorts keys by code point,
// wraps them with the evaluation id ({"criteria":{…},"evaluation_id":"…"}, key-sorted compact JSON) and hashes with SHA-256 via Web Crypto.

export const HASH_RECIPE_VERSION = "v2";

const normalise = (c, v) => {
  if (c.kind === "bool") return v === null || v === undefined ? undefined : v ? "true" : "false";
  if (v === null || v === undefined || v === "") return undefined;
  if (c.kind === "select") { const s = String(v).trim(); return c.options && !c.options.some((o) => o.value === s) ? undefined : s; }
  const f = Number(v);
  if (!Number.isFinite(f)) return undefined;
  return Number.isInteger(f) ? String(f) : f.toFixed(6).replace(/0+$/, "").replace(/\.$/, "");
};

export const canonicalCriteria = (inputs, criteria, evaluationId) => {
  const byKey = Object.fromEntries(criteria.map((c) => [c.key, c]));
  const keys = Object.keys(byKey).sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
  const obj = {};
  for (const k of keys) { const s = normalise(byKey[k], inputs[k]); if (s !== undefined) obj[k] = s; }
  return JSON.stringify({ criteria: obj, evaluation_id: String(evaluationId) });
};

export const sha256Hex = async (text) => {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return "0x" + Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const termSheetDigest = (inputs, criteria, evaluationId) => sha256Hex(canonicalCriteria(inputs, criteria, evaluationId));

export const isDigest = (s) => /^0x[0-9a-fA-F]{64}$/.test(s || "");
